import { RaidSettlementView } from '../shared/RaidSettlementView.jsx';

export function MobileRaidSettlement() {
  return <RaidSettlementView mobile />;
}
